import React, { useState } from 'react'
import { useEffect } from 'react';
import Helmet from 'react-helmet';
import PageFlip from '../../components/PageFlip';
import components from '../../assets/images/stegvision/components.png';
import dashboard from '../../assets/images/stegvision/dashboard.png';
import Warning from '../../components/Warning';
import WorkHeader from '../../components/WorkHeader';
import Paragraph from '../../components/Paragraph';
import ProjectImage from '../../components/ProjectImage';


function AMNotify() {

    useEffect(() => {
        document.getElementById("works").className = 'text-secondary line-through'
        window.scrollTo(0, 0);
    }, []);

    const [bg, setBg] = useState('#FD506D');
    const [accent, setAccent] = useState('#FD506D');
    const [main, setMain] = useState('#D6A158');


    return (
        <div className='bg-[#202226] pb-20'>
            <div className='flex flex-col w-full overflow-x-hidden items-center'>
                <Helmet>
                    <title>Stephanie Zhang  ⎯  AMNotify</title>
                </Helmet>
                <WorkHeader
                    title='AMNotify'
                    bg={bg}
                    accent={accent}
                    timeline='January 2021'
                    role='Developer'
                    skills='HTML/CSS, API'
                    text='#fff'
                />
                <div className='flex flex-col gap-12 w-full items-center my-12'>
                    <Warning title='This is under construction!' 
                    desc='I would love to share the work I have done for AMNotify, but this page is still under construction. If you would like to see the designs up close, contact me!' 
                    link='mailto:stephaniey.zhang@mail.utoronto.ca' 
                    button='email me :-)' 
                    bg={bg}
                    buttoncolour='#fff'/>
                    <PageFlip next='Front-End' nextLink='/frontend' />
                </div>
            </div>
        </div>
    );
}

export default AMNotify;